import { useEffect, useState } from "react"
import Cookies from "js-cookie"

interface CookieProducts {
  sku: string
  name: string
  price: number
  qty: number
}

export interface CartCookieData {
  item_count: number
  item_qty: number
  grand_total: number
  currency: string
  cart_id: string
  items?: CookieProducts[]
}

interface CartCookie {
  cartData: CartCookieData | null | undefined
}

const useCartCookie = (): CartCookie => {
  const [cartData, setCartData] = useState<CartCookieData | null>()

  useEffect(() => {
    const cartCookies = Cookies.get("cart_external")
    if (cartCookies) {
      setCartData(JSON.parse(cartCookies))
    } else {
      setCartData(null)
    }
  }, [])

  return { cartData }
}

export default useCartCookie
